<template>
  <div id="digital-flop">
    <div
      class="digital-flop-item"
      v-for="item in digitalFlopData"
      :key="item.title"
      @click="handleClick(item)"
    >
      <div class="digital-flop-title" style="text-align: right">
        {{ item.title }}
      </div>
      <div class="digital-flop">
        <dv-digital-flop
          :config="item.number"
          style="width: 100px; height: 50px"
        />
        <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10 />
    <div class="cliclDialog" v-if="showDialog">
      <div class="cliclDialog-title">完成项目</div>
      <div class="cliclDialog-close" @click="showDialog = false">X</div>
      <dv-scroll-board :config="config" style="height: calc(100% - 40px)" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DigitalFlop",
  data() {
    return {
      digitalFlopData: [],
      showDialog: false,
      config: {
        header: ["时间", "项目名称"],
        data: [
          ["2024-02-01 19:25:00", "尉氏百茂硅胶生产项目"],
          ["2024-02-02 17:25:00", "焦作产城融合示范区高职院校建设项目"],
          ["2024-02-03 16:25:00", "恒晖精细化工产业项目"],
          ["2024-02-05 14:25:00", "综保区平原智能汽车涂装生产线项目"],
          ["2024-02-07 12:25:00", "综保区三期电子信息产业园项目"],
          ["2024-02-08 11:25:00", "焦作运粮河引黄调蓄水利工程"],
          ["2024-02-09 10:25:00", "连霍高速焦作西收费站开通项目"],
          ["2024-02-10 09:25:00", '河南省"万人助万企"尉氏对接服务项目'],
        ],
        index: true,
        columnWidth: [50, 170],
        align: ["center"],
        rowNum: 7,
        headerBGC: "#1981f6",
        headerHeight: 30,
        rowHeight: 20,
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
      },
    };
  },
  methods: {
    createData() {
      const { randomExtend } = this;

      this.digitalFlopData = [
        {
          title: "企业总投资资本",
          number: {
            number: [randomExtend(3000, 4000)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
            },
          },
          unit: "万元",
        },
        {
          title: "GDP总量",
          number: {
            number: [randomExtend(20000, 30000)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#40faee",
              fontWeight: "bold",
            },
          },
          unit: "万元",
        },
        {
          title: "投资项目",
          number: {
            number: [randomExtend(400, 600)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#f46827",
              fontWeight: "bold",
            },
          },
          unit: "个",
        },
        {
          title: "审批项目",
          number: {
            number: [randomExtend(400, 600)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
            },
          },
          unit: "个",
        },
        {
          title: "完成项目",
          number: {
            number: [randomExtend(400, 600)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#f46827",
              fontWeight: "bold",
            },
          },
          unit: "个",
        },
        {
          title: "备案项目",
          number: {
            number: [randomExtend(400, 600)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#40faee",
              fontWeight: "bold",
            },
          },
          unit: "个",
        },
        {
          title: "2023企业总投资经营情况",
          number: {
            number: [500],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
            },
          },
          unit: "万元",
        },
        {
          title: "2024企业总投资经营情况",
          number: {
            number: [800],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#f46827",
              fontWeight: "bold",
            },
          },
          unit: "万元",
        },
        {
          title: "2025企业总投资经营情况",
          number: {
            number: [100],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#40faee",
              fontWeight: "bold",
            },
          },
          unit: "万元",
        },
      ];
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10);
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      }
    },
    handleClick(item) {
      if (item.title == "完成项目") {
        this.showDialog = true;
      }
    },
  },
  mounted() {
    const { createData } = this;

    createData();

    setInterval(createData, 30000);
  },
};
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 15%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.5);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 11%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}
.cliclDialog {
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 600px;
  height: 400px;
  background-color: rgba(6, 30, 93, 0.5);
  border: 2px solid rgb(0, 72, 255);
  .cliclDialog-title {
    height: 30px;
    font-size: 26px;
    letter-spacing: 5px;
    margin-bottom: 10px;
    text-align: center;
    font-weight: bolder;
    color: #fff;
  }
  .cliclDialog-close {
    position: absolute;
    cursor: pointer;
    top: 10px;
    right: 10px;
    font-size: 26px;
    font-weight: bolder;
    color: #fff;
  }
}
</style>
